import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getTokenPriceHistory : [],
  getRiskFactors       : [],
}, { prefix: "offering_summary_" });

export { Types, Creators };
